import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";
import { GetData } from "./Functions/SettingData";
import qs from "qs";

export const getFleetPerformanceKpis = async (globalFilters, localFilters) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, 'fleetPerformance');

  var config = {
    method: "get",
    url: `/api/fleet/energy-events/analytics/kpis`,
    params: localFilters,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getFleetPerformanceAnalyticsList = async (
  globalFilters,
  localFilters
) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, 'fleetPerformance');

  const apiParams = {
    ...localFilters,
    filters: JSON.stringify(localFilters.filters || []),
  };

  var config = {
    method: "get",
    url: `/api/fleet/energy-events/analytics/list`,
    params: apiParams,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getFleetPerformanceAnalyticsTimeseries = async (
  globalFilters,
  localFilters
) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, 'fleetPerformance');

  const apiParams = {
    ...localFilters,
    filters: JSON.stringify(localFilters.filters || []),
  };

  var config = {
    method: "get",
    url: `/api/fleet/energy-events/analytics/timeseries`,
    params: apiParams,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getFleetPerformanceAnalyticsListActions = async (
  globalFilters,
  params
) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, 'fleetPerformance');

  const apiParams = {
    ...params,
    filters: JSON.stringify(params.filters || []),
  };

  var config = {
    method: "post",
    url: `/api/fleet/energy-events/analytics/list-actions`,
    data: apiParams,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

